import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  MutationUpdateDispatchSummaryBulkArgs,
  UpdateDispatchSummaryBulkResponse,
  UpdateDispatchSummaryInput,
  UpdateDispatchSummaryValuesInput,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';
import { getProperty, queryInput } from '@/utils';

import { TypedDocumentNode } from '@apollo/client';
import { UpdateDispatchSummary } from '@/features/SummaryHistory/api/queries/UpdateDispatchSummary';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = Partial<UpdateDispatchSummaryValuesInput & { id: string }>[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<UpdateDispatchSummaryBulkResponse>;
}

// UpdateDispatchSummary Service
export const { updateDispatchSummary, useUpdateDispatchSummary } = ((): {
  updateDispatchSummary: ServiceMethod;
  useUpdateDispatchSummary: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(UpdateDispatchSummary).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<UpdateDispatchSummaryBulkResponse> => {
        debug.log('updateDispatchSummary,updateDispatchSummary.input', 'INPUT', payload);
        const updates: UpdateDispatchSummaryInput[] =
          payload
            ?.filter(({ id }) => id)
            ?.map(
              ({ id, ...value }): UpdateDispatchSummaryInput => ({
                query: [
                  {
                    id: queryInput(id),
                  },
                ],
                value: {
                  callVolume: value?.callVolume || null,
                  commentsFaxallCheck: value?.commentsFaxallCheck || null,
                  commentsRepeatDistractedOffenders: value?.commentsRepeatDistractedOffenders || null,
                  commentsRepeatSpeedingOffenders: value?.commentsRepeatSpeedingOffenders || null,
                  dispatcherAssetCamerasWorking: value?.dispatcherAssetCamerasWorking || null,
                  dispatcherAssetCamerasWorkingNotes: value?.dispatcherAssetCamerasWorkingNotes || null,
                  dispatcherDayOverview: value?.dispatcherDayOverview || null,
                  dispatcherEightByEightIssue: value?.dispatcherEightByEightIssue || null,
                  dispatcherId: value?.dispatcherId || null,
                  dispatcherPassdown: value?.dispatcherPassdown || null,
                  dispatcherServiceIssues: value?.dispatcherServiceIssues || null,
                  dispatcherShift: value?.dispatcherShift || null,
                  dispatcherSoftwareIssues: value?.dispatcherSoftwareIssues || null,
                  dispatcherStation: value?.dispatcherStation || null,
                  dispatcherStationVansIssues: value?.dispatcherStationVansIssues || null,
                  manifestsDrivingIssues: value?.manifestsDrivingIssues || null,
                  manifestsTaxis: value?.manifestsTaxis || null,
                  manifestsTrainingIssues: value?.manifestsTrainingIssues || null,
                  chatVolume: value?.chatVolume || null,
                  dispatcherWasThereEightByEightIssue: value?.dispatcherWasThereEightByEightIssue || null,
                },
              })
            ) ?? [];
        const args: MutationUpdateDispatchSummaryBulkArgs = {
          input: {
            updates,
          },
        };
        debug.log('updateDispatchSummary,updateDispatchSummary.payload', 'PAYLOAD', args);
        const opts = { merge: options?.merge ? 'updateDispatchSummaryBulk' : undefined };
        const res = await fn(args, opts);
        debug.log('updateDispatchSummary,updateDispatchSummary.response', 'RESPONSE', res);
        return getProperty('updateDispatchSummaryBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    updateDispatchSummary: fetch,
    useUpdateDispatchSummary: useService,
  };
})();
